"use client";

import { usePostHog } from "@posthog/next";
import { useEffect, useRef } from "react";
import { setBrowserPostHog } from "@/lib/posthog-browser";
import { filterPostHogEvent } from "@/utils/common/posthogEventFilter";

/**
 * Applies non-serializable PostHog client config after the SDK initializes.
 * Must render inside {@link PostHogProvider}.
 */
export function PostHogClientBridge() {
  const posthog = usePostHog();
  const configured = useRef(false);

  useEffect(() => {
    if (!posthog || configured.current) return;

    posthog.set_config({ before_send: filterPostHogEvent });
    setBrowserPostHog(posthog as Parameters<typeof setBrowserPostHog>[0]);
    configured.current = true;
  }, [posthog]);

  return null;
}
